import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { UKPostalCode } from '@/utils/patterns/rgex';
import { getData, postData } from '@/services/api.service';
import { end_points } from '@/services/endpoints';
import toaster from '@/components/toaster/toaster';

const addressSchema = yup.object({
  // name: yup.string().required('Name is required'),

  // phone: yup
  //   .string()
  //   .required('Phone is required')
  //   .matches(/^[0-9]{10}$/, 'Phone number must be 10 digits'),

  address: yup.string().required('Address is required'),

  city: yup.string().required('City is required'),

  state: yup.string().required('City is required'),

  country: yup.string().required('Country is required'),

  zip: yup
    .string()
    .required('Postal code is required')
    .matches(UKPostalCode, 'Enter a valid postal code')
    .trim(),
});

export default function AddEditAddressForm(props) {
  const { editAddress, getAddress, setEditAddress } = props;
  const [customerId, setcustomerId] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editAddress) {
      // setValue('name', editAddress?.name);
      // setValue('phone', editAddress?.phone);
      setValue('address', editAddress?.address);
      setValue('city', editAddress?.city);
      setValue('state', editAddress?.state);
      setValue('country', editAddress?.country);
      setValue('zip', editAddress?.zip);
    }
  }, [editAddress]);

  const getCheckoutDetails = async () => {
    try {
      const response = await getData(end_points.checkout.url);
      setcustomerId(response?.data?.customer_data?.customer?.id);
    } catch (error) {}
  };

  useEffect(() => {
    getCheckoutDetails();
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm({
    resolver: yupResolver(addressSchema),
    defaultValues: {
      name: '',
      phone: '',
      address: '',
      city: '',
      state: '',
      country: '',
      zip: '',
    },
  });

  const onSubmit = async (data: any) => {
    setLoading(true);
    data.customer_id = customerId;
    let url = editAddress
      ? `${end_points.address.update_address}/${editAddress?.id}`
      : end_points.address.add_address;
    try {
      const response = await postData(url, data);
      if (response?.status == 201 || response?.status == 200) {
        if (editAddress) {
          setEditAddress();
          toaster.success('Address updated successfully');
        }
        reset();
        getAddress();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="mt-3" onSubmit={handleSubmit(onSubmit)}>
      <div className="row">
        <div className="col-md-12 mb-3">
          <div className="text-block row">
            {/* <div className="form-group col-md-6">
                        <Controller
                          name="name"
                          control={control}
                          render={({ field }) => (
                            <>
                              <input
                                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="Name"
                                {...field}
                              />
                              {errors.name && (
                                <div className="invalid-feedback">
                                  {errors.name.message}
                                </div>
                              )}
                            </>
                          )}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <Controller
                          name="phone"
                          control={control}
                          render={({ field }) => (
                            <>
                              <input
                                className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                type="text"
                                placeholder="Phone"
                                {...field}
                              />
                              {errors.phone && (
                                <div className="invalid-feedback">
                                  {errors.phone.message}
                                </div>
                              )}
                            </>
                          )}
                        />
                      </div> */}
            <div className="form-group col-md-12">
              <Controller
                name="address"
                control={control}
                render={({ field }) => (
                  <>
                    <input
                      className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                      type="text"
                      placeholder="Address *"
                      {...field}
                    />
                    {errors.address && (
                      <div className="invalid-feedback">
                        {errors.address.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <Controller
                name="city"
                control={control}
                render={({ field }) => (
                  <>
                    <input
                      className={`form-control ${errors.city ? 'is-invalid' : ''}`}
                      type="text"
                      placeholder="City *"
                      {...field}
                    />
                    {errors.city && (
                      <div className="invalid-feedback">
                        {errors.city.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <Controller
                name="state"
                control={control}
                render={({ field }) => (
                  <>
                    <input
                      className={`form-control ${errors.state ? 'is-invalid' : ''}`}
                      type="text"
                      placeholder="State"
                      {...field}
                    />
                    {errors.state && (
                      <div className="invalid-feedback">
                        {errors.state.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <Controller
                name="country"
                control={control}
                render={({ field }) => (
                  <>
                    <input
                      className={`form-control ${errors.country ? 'is-invalid' : ''}`}
                      type="text"
                      placeholder="Country *"
                      {...field}
                    />
                    {errors.country && (
                      <div className="invalid-feedback">
                        {errors.country.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>
            <div className="form-group col-md-3">
              <Controller
                name="zip"
                control={control}
                render={({ field }) => (
                  <>
                    <input
                      className={`form-control ${errors.zip ? 'is-invalid' : ''}`}
                      type="text"
                      placeholder="Zip / Postal code *"
                      {...field}
                    />
                    {errors.zip && (
                      <div className="invalid-feedback">
                        {errors.zip.message}
                      </div>
                    )}
                  </>
                )}
              />
            </div>
          </div>
        </div>
      </div>

      <button type="submit" className="button bg-primary style1">
        {loading ? 'loading...' : <> {editAddress ? 'Update' : 'Save'} </>}
      </button>

      <button
        type="button"
        className="button bg-secondary style1"
        style={{ marginLeft: '10px' }}
        onClick={() => {
          reset();
          setEditAddress(null);
        }}
      >
        Cancel
      </button>
    </form>
  );
}
